/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'
import * as AdminDefs from './defs.defs.js'

const $nsid = 'com.atproto.admin.getAccountInfos'

type $nsid = typeof $nsid

export { $nsid }

export const $params = /*#__PURE__*/ l.params({
  dids: /*#__PURE__*/ l.array(/*#__PURE__*/ l.string({ format: 'did' })),
})

export type $Params = l.InferOutput<typeof $params>

export const $output = /*#__PURE__*/ l.jsonPayload({
  infos: /*#__PURE__*/ l.array(
    /*#__PURE__*/ l.ref<AdminDefs.AccountView>(
      (() => AdminDefs.accountView) as any,
    ),
  ),
})

export type $Output<B = l.BinaryData> = l.InferPayload<typeof $output, B>
export type $OutputBody<B = l.BinaryData> = l.InferPayloadBody<
  typeof $output,
  B
>

/** Get details about some accounts. */
const main = /*#__PURE__*/ l.query($nsid, $params, $output)

export { main }

const $lxm = $nsid

type $lxm = typeof $lxm

export { $lxm }
